<app-structure-selection-field (selectionChanged)="onSelectionChanged($event)" [selection]="currentSelection"></app-structure-selection-field>
